import colors from 'styles/colors'

const styles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.placebo
  },
  topContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1px',
    padding: '24px',
    backgroundColor: colors.white
  },
  iconCountContainer: {
    height: '26.6px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px'
  },
  countContainer: {
    height: '26.6px',
    width: '31.44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '13.3px',
    backgroundColor: colors.secondary
  },
  count: {
    color: colors.white,
    fontFamily: 'Barlow',
    fontSize: 17,
    fontWeight: 700,
    letterSpacing: 0,
    lineHeight: '17.1px',
    textAlign: 'center'
  },
  title: {
    color: colors.lightGray,
    fontFamily: 'Barlow',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '0.23px',
    lineHeight: '24px',
    marginBottom: '8px'
  },
  text: {
    color: colors.lightGray,
    fontFamily: 'Barlow',
    fontSize: 12,
    lineHeight: '17px'
  },
  bottomContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '36.5px',
    paddingLeft: '24px',
    backgroundColor: colors.white
  },
  link: {
    color: colors.primary,
    fontFamily: 'Barlow',
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '17px',
    cursor: 'pointer'
  }
}

export default styles
